const GlobalDefs = {
    ErrorType: {
        ERROR_LOADING_PROP: 0,
        ERROR_LOADING_ROOM: 1,
        ERROR_ROOM_HAS_NO_MODEL: 2,
        ERROR_INVALID_PROP: 3,
		ERROR_LOADING_ROOM_INFO_API: 4,
    },

    RoomVersions: {
        MINIMUM_SPLIT_PLANES: 2,
        MINIMUM_DOORWAY_DETECTION: 3,
        MINIMUM_SCALE_ALL_FIXTURES: 4,
        MINIMUM_CONSISTENT_PLACEMENT: 5,
        MINIMUM_SLOPED_CEILING_TOOL: 6,
        MINIMUM_BEAMS_AND_PANELS: 7,
        MINIMUM_WALLS_SINGLE_MESH: 8,
        MINIMUM_DYNAMIC_SUBMESHES: 9,
        MINIMUM_MESH_GENERATION_V2: 10,
        MINIMUM_NON_UNIFORM_TEXTURE_SCALING: 11,
        MINIMUM_MATERIAL_MODIFICATION_FOR_ALL: 12,
        MINIMUM_ROOM_FEATURES: 13,
        MINIMUM_NODE_GRAPH_FIXTURE: 14
    },

    MAXDataVersions: {
        MINIMUM_ORIGINAL: 0,
        MINIMUM_WALLS_SINGLE_MESH: 1,
        MINIMUM_TWEAKING_ROOM_MESH: 2,
        MINIMUM_MESH_GENERATION_V2: 3,
        MINIMUM_MATERIAL_MODIFICATION_FOR_ALL: 4,
        MINIMUM_WALTER_REDV2: 5
    },

    /**
     * We need this because otherwise our models, etc. are all in millimeters; this means
     * we will lose a lot of precision if we just keep them, so we convert everything to
     * meters.
     */
    fGlobalInputScale: 0.001,

    BABYLON_S3_KEY: 'babylon',
    DEFAULT_BMODEL_NAME: "model.babylon",
    g_strNoneKey: '__none__',
    g_strAllKey: '__all__',

    GroupNames: {
        WALLS: 'WALL_GRP',
        FLOOR: 'FLOOR_GRP',
        CEILING: 'CEILING_GRP',
        CEILING_BEAMS: 'CEILING_BEAMS_GRP',
        WINDOW: 'WINDOW_GRP',
        DOOR: 'DOOR_GRP',
        OTHER: 'OTHER_FIXTURES_GRP',
        ENV: 'ENVIRON_GRP',
        STAIRCASE: 'STAIRCASE_GRP',
        FIREPLACE: 'FIREPLACE_GRP'
    },

	LIKE_TYPE: {
		NONE: 0,
		LIKED: 1,
		DISLIKED: -1,
	},

};

export default GlobalDefs;

export const AXES = {
    XAXIS:      0x0001,
    YAXIS:      0x0002,
    ZAXIS:      0x0004,
};
export const ALL_AXES = (AXES.XAXIS | AXES.YAXIS | AXES.ZAXIS);
export const AXES_NONE = 0x0000;

export const AXIS_NAMES = {
	[AXES.XAXIS]: 'xAxis',
	[AXES.YAXIS]: 'yAxis',
	[AXES.ZAXIS]: 'zAxis',
};

export const SHORT_AXIS_NAMES = {
	[AXES.XAXIS]: 'x',
	[AXES.YAXIS]: 'y',
	[AXES.ZAXIS]: 'z',
};